import { Serializer } from '@teem/generic/serializer';
import { Resource } from '@teem/generic/resource';

export class ClientSerializer implements Serializer {
	fromJson(json: any): Client {
		let client = new Client(json);
		return client;
	}

	toJson(client: Client): any {
		return client;
	}
}

export class Client implements Resource {
	public id: number;
	public uuid: string;
	public first_name: string = null;
	public last_name: string = null;
	public full_name: string;
	public email: string;
	public dial_code: string;
	public phone: string;
	public business_name: string;
	public tax_reg_number: string;
	public country_id: number = null;
	public website: string;
	public address: string;
	public date_of_birth: Date;
	public projects: Array<any>;
	public active_project: number;
	public completed_project: number;
	public paid_amount: number;
	
	public buyer_first_name: string = null;
	public buyer_last_name: string = null;
	public buyer_address: string = null;
	public buyer_vat_number: string = null;
	public buyer_cr_number: string = null;

	constructor(input?: any) {
		if (input) {
			Object.assign(this, input);

			if (!input.full_name && input.first_name) {
				this.full_name = this.first_name + ' ' + this.last_name;
			}
		}
	}
}